import React from "react";

const Testimonial = () => {
  return (
    <React.Fragment>
      <section className="py-5 bg-white">
        <div className="container">
          {/* Testimonials */}
          <div className="row justify-content-center">
            <div className="col-12 text-center">
              <div className="section-title mb-4 pb-2">
                <h4 className="title mb-4">Trusted by Fintech Leaders</h4>
                <p className="text-muted para-desc mx-auto mb-0">
                  See what industry leaders say about our API platform.
                </p>
              </div>
            </div>
            {/*end col*/}

            <div className="col-lg-4 col-md-6 mt-4">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body p-4">
                  <div className="d-flex align-items-center mb-4">
                    <img
                      src="/images/user-icon.png"
                      className="rounded-circle me-3"
                      width="60"
                      alt="User"
                    />
                    <div>
                      <h6 className="mb-0">Rahul Sharma</h6>
                      <small className="text-muted">CTO, Fintech Startup</small>
                    </div>
                  </div>
                  <p className="text-muted">
                    "Formax Pay's APIs helped us launch our payment gateway in 2
                    weeks instead of 6 months. The documentation is excellent
                    and support is responsive."
                  </p>
                  <div className="text-warning">
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                  </div>
                </div>
              </div>
            </div>
            {/*end col*/}

            <div className="col-lg-4 col-md-6 mt-4">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body p-4">
                  <div className="d-flex align-items-center mb-4">
                    <img
                      src="/images/user-icon.png"
                      className="rounded-circle me-3"
                      width="60"
                      alt="User"
                    />
                    <div>
                      <h6 className="mb-0">Priya Patel</h6>
                      <small className="text-muted">Product Head, NBFC</small>
                    </div>
                  </div>
                  <p className="text-muted">
                    "The compliance-first approach gave us confidence. We've
                    processed over ₹500 Cr in transactions with 99.99% uptime."
                  </p>
                  <div className="text-warning">
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star-half-alt"></i>
                  </div>
                </div>
              </div>
            </div>
            {/*end col*/}

            <div className="col-lg-4 col-md-6 mt-4">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-body p-4">
                  <div className="d-flex align-items-center mb-4">
                    <img
                      src="/images/user-icon.png"
                      className="rounded-circle me-3"
                      width="60"
                      alt="User"
                    />
                    <div>
                      <h6 className="mb-0">Amit Kumar</h6>
                      <small className="text-muted">CEO, SaaS Platform</small>
                    </div>
                  </div>
                  <p className="text-muted">
                    "Their banking APIs integrated seamlessly with our platform.
                    The real-time monitoring dashboard is a game-changer for our
                    operations team."
                  </p>
                  <div className="text-warning">
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                  </div>
                </div>
              </div>
            </div>
            {/*end col*/}
          </div>
          {/*end row*/}
        </div>
      </section>
    </React.Fragment>
  );
};

export default Testimonial;
